import { Component, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RowArgs } from '@progress/kendo-angular-grid';
import { truncate } from 'lodash';
import { CommonService } from 'src/app/Service/Common.service';
import { DocumentService } from 'src/app/Service/document/document.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { TenderQuantityService } from 'src/app/Service/tender-quantity/tender-quantity.service';
import { WorkflowTemplateService } from 'src/app/Service/workflow-template/workflow-template.service';
import { IElementInputModel } from 'src/app/ViewModel/DocumentModel';
import { StandardOutputModel } from 'src/app/ViewModel/StandardOutputModel';
import { ITenderTranDetailsInputModel, ITenderTranInputModel, ITenderTranListInputModel } from 'src/app/ViewModel/WorkflowTemplateModel';

@Component({
  selector: 'app-workflow-tender-quantity',
  templateUrl: './workflow-tender-quantity.component.html',
  styleUrls: ['./workflow-tender-quantity.component.css']
})
export class WorkflowTenderQuantityComponent implements OnInit {

  public documentElements: IElementInputModel[] = [];
  public elementsList!: any[];
  public existsTenderList: any[] = [];
  public tenderlist: any[] = [];
  public tenderTranList: any[] = [];
  public tenderTranDetailsModel: ITenderTranDetailsInputModel[] = [];
  public projectId!: number;
  public groupId!: number;
  public documentId!: number;
  public docNo!: string;
  public revisionNo!: string;
  public struct_DED_Id: any;
  public disc_DED_Id: any;
  public quantity!: string;
  public isFilled: any;
  public transtype: string = 'INSERT';
  public isReadMode: boolean = true;
  private editedRowIndex!: number;
  public TenderTranDetailInput: ITenderTranDetailsInputModel[] = [];

  @ViewChild('tqGrid') tqGrid: any;




  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<WorkflowTenderQuantityComponent>,
    private dialog: MatDialog,
    private _docService: DocumentService,
    private notificationService: NotificationService,
    private commonService: CommonService,
    public workflowTemplateService: WorkflowTemplateService,
    private tenderQuantityService: TenderQuantityService
  ) { }

  ngOnInit() {
    this.projectId = this.commonService.getProjectId();
    if (this.data != 0) {
      this.documentId = this.data.documentId;
      this.revisionNo = this.data.revisionNo;
      this.docNo = this.data.docNo;
      this.quantity = this.data.isQuantityApplicable;
      this.isReadMode = this.data.isReadMode;

      this.getDocumentElements();
    }
  }
  closeDialog() {


    if (this.transtype == 'APPROVE' || this.transtype == 'SUBMIT') {
      this.dialogRef.close(true);
    }
    else {
      this.dialogRef.close(false);
    }
  }

  getDocumentElements() {
    this._docService.getDocumentElementsById({ docId: this.documentId }).subscribe(
      (pde: IElementInputModel[]) => {
        this.documentElements = pde;
        this.disc_DED_Id = this.documentElements.filter(x => x.deDescription == 'Discipline')[0].dedId;
        this.struct_DED_Id = this.documentElements.filter(x => x.deDescription == 'Structure / Package')[0].dedId;
        this.getTenderList();
      });
  }
  getTenderList() {
    this.tqGrid.defaultSelection.selectedKeys = [];
    //Reset the isselected flag as false
    this.tenderlist.forEach(x => x.isSelected = false);
    this.tenderQuantityService.getElementProjectConfigure(this.disc_DED_Id).subscribe(data => {
      this.elementsList = data;
      if (!!this.elementsList) {
        this.elementsList.forEach(element => {
          this.tenderQuantityService.getItemProjectConfigure(element).subscribe((data: any[]) => {
            if (!!data && data.length > 0) {
              let teId = data[0].tE_Id;
              let element: any = this.elementsList.filter(x => x.tE_Id == teId)[0];
              if (!!element) {
                element.items = data;
              }
            }
          });
        });
      }
    });
    let obj1: ITenderTranListInputModel;
    obj1 = {
      projectId: this.projectId,
      documentId: this.documentId,
      revisionNo: this.revisionNo,
      discDEDId: this.disc_DED_Id,
      structDEDId: this.struct_DED_Id
    }
    this.workflowTemplateService.getTenderTranWorkflowDetails(obj1).subscribe(data => {
      this.tenderlist = data;
      this.tenderlist.forEach(x => x.isSelected = x.actualQty > 0 ? true : false);
      this.existsTenderList = this.tenderlist;

    });
  }

  getItemData(data: any, stage: any) {
    let setItem = data.tenderElementDetails.filter((value: { tE_Description: any; }) => value.tE_Description == stage.tE_Description)[0];
    if (!!setItem && !!setItem.tI_Description)
      return setItem.tI_Description;
  }

  /**
  * Multiple select of listed documents for approval or reject
  * @param event
  *
  */
  onSelectionChange(event: any): void {
    if (event['selectedRows'].length > 0) {
      event['selectedRows'].forEach((element: { dataItem: { isSelected: boolean; }; }) => {
        element.dataItem.isSelected = true;
      });
    }
    if (event['deselectedRows'].length > 0) {
      event['deselectedRows'].forEach((element: { dataItem: { isSelected: boolean; }; }) => {
        element.dataItem.isSelected = false;
      });
    }
  }
  filterSelected() {
    this.tenderlist = this.tenderlist.filter(x => x.isSelected == true);
  }
  viewAll() {
    this.tenderlist = this.existsTenderList;
  }

  saveTenderWF(val: string) {
    this.transtype = val;
    let tenderlist1: any;
    let submittedtag: boolean = false;
    let approvedtag: boolean = false;
    if (val == 'SUBMIT') {
      submittedtag = true;
    }
    else {
      submittedtag = false
    }
    if (val == 'APPROVE') {
      approvedtag = true;
    }
    else {
      approvedtag = false
    }


    if (this.tenderlist.length == 0) {
      // if (val == 'SUBMIT' || val == 'APPROVE') {
      //   this.notificationService.showToast("Please select all items", "Warning");
      // }
      // if (val == 'INSERT') {
      this.notificationService.showToast("Please Add or Configure Tender Quantity", "Warning");
      // }
    }
    else {


      this.isFilled = this.tenderlist.filter(x => x.actualQty == 0);
      let alertmessage1 = "Are you sure to perform the clicked action?";
      let alertmessage2 = "Some of the fields are not entered. Do You want to proceed?";
      let alertmessage = "";
      if (this.isFilled.length > 0) {
        alertmessage = alertmessage2;
      }
      else {
        alertmessage = alertmessage1;
      }
      this.notificationService.showPopup(alertmessage, 'Confirm').then(data => {
        if (data == 'yes') {
          this.tenderlist.forEach(element => {

            this.tenderTranDetailsModel = this.tenderlist.map(x => {
              let result: ITenderTranDetailsInputModel = {
                docId: this.documentId,
                revisionNo: this.revisionNo,
                tenderId: x.t_Id,
                plannedQty: x.plannedQty,
                actualQty: x.actualQty,
                remarks: x.remarks,
                isActive: true
              }
              return result;

            });

          });

          let inputModel: ITenderTranInputModel = {
            transType: val,
            tenderList: this.tenderTranDetailsModel,
            submittedTag: submittedtag,
            approvedTag: approvedtag,
            memberId: this.commonService.getLoggedInUserId()
          };
          this.workflowTemplateService.insertUpdateTenderTransaction(inputModel).subscribe((res: StandardOutputModel) => {
            if (res.successCode == 200) {
              this.notificationService.showToast(res.successMessage, "Success");
            }
            else if (res.successCode == 500) {
              this.notificationService.showToast(res.successMessage, "Error");
            }
          });

          this.closeDialog();

        }
      });
    }


  }

}
